import { CampaignRequestModel } from './../business-entities/campaign-modal';
import { Injectable } from '@angular/core';
import { CampaignDataServiceService } from '../data-services/campaign-data-service.service';

@Injectable({
  providedIn: 'root'
})
export class CampaignServiceService {

  constructor(private campaignDataServiceService: CampaignDataServiceService) { }

  getCampaigns(campaignRequestModel : CampaignRequestModel): Promise<any> {
    return this.campaignDataServiceService.getCampaigns(campaignRequestModel);
  }

  getCampaignById(id): Promise<any>{
    return this.campaignDataServiceService.getCampaignById(id);
  }

  addUpdateCampaigns(param: any): Promise<any>{
    return this.campaignDataServiceService.addUpdateCampaigns(param);
  }

  deleteCampaign(id): Promise<any>{
    return this.campaignDataServiceService.deleteCampaign(id);
  }


}
